<label class="input-label">{{ label }}</label>
<textarea [cols]="cols" [rows]="rows" class="shared-input" [formControl]="control" [placeholder]="placeholder"></textarea>
@if (control.invalid && control.touched) {
  <p class="input-err">Invalid field.</p>
}
